import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { StyledRow } from '../styled';
import DetailTitle from 'modules/Common/DetailTitle';

const PincodeRow = React.memo(({ pincode }) => {
  return (
    <StyledRow>
      <Fragment>
        <DetailTitle>PINCODE</DetailTitle>
        <div>{pincode}</div>
      </Fragment>
    </StyledRow>
  );
});

PincodeRow.propTypes = {
  pincode: PropTypes.string,
};

PincodeRow.defaultProps = {
  pincode: null,
};

export default PincodeRow;
